import React from 'react'

//context
import { useContext, useState, useEffect } from 'react'
//player context
import { CharacterContext } from '../../../contexts/character'
//custom select
import Select from 'react-select'

//Job Ids
import { EAJL_THIRD, KAGEROU, OBORO, REBELLION } from '../../../data/jobID'

function StatSelect(props) {
	const { job, changeBaseStat, getBaseStat } = useContext(CharacterContext)
	const [maxStat, setMaxStat] = useState(Number(99))
	const [options, setOptions] = useState([])
	const [selectedValue, setSelectedValue] = useState([
		{
			value: 1,
			label: 1,
			key: props.id + 1,
		},
	])

	useEffect(() => {
		if (
			job & EAJL_THIRD ||
			job === KAGEROU ||
			job === OBORO ||
			job === REBELLION
		)
			setMaxStat(Number(130))
		else setMaxStat(Number(99))
	}, [job])

	useEffect(() => {
		const newOptions = []
		for (let i = 1; i <= maxStat; i++) {
			newOptions.push({
				value: i,
				label: i,
				key: props.id + i,
			})
		}
		setOptions(newOptions)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [maxStat])

	useEffect(() => {
		let stat = getBaseStat(props.id)
		if (stat > maxStat) changeBaseStat(Number(1), props.id)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [maxStat, props.id])

	useEffect(() => {
		if (options.length > 0) {
			let statValue = 1
			if (options.find((opt) => opt.value === props.test[props.id]))
				statValue = props.test[props.id]
			else statValue = 99
			let newopt = options.find((opt) => opt.value === statValue)

			if (newopt) {
				changeBaseStat(Number(statValue), props.id)
				setSelectedValue(newopt)
			} else {
				console.log('not found')
				setSelectedValue([
					{
						value: Number(statValue),
						label: Number(statValue),
						key: props.id + Number(statValue),
					},
				])
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.id, props.test, options])

	return (
		<div className='DivStat'>
			<Select
				styles={props.customStyles}
				value={selectedValue}
				id={props.id}
				className='StatSelect'
				onChange={(event) => {
					changeBaseStat(Number(event.value), props.id)
					let newopt = options.find(
						(opt) => opt.value === event.value,
					)
					if (newopt) setSelectedValue(event)
					else {
						console.log('not found')
						setSelectedValue([
							{
								value: Number(event.value),
								label: Number(event.value),
								key: props.id + Number(event.value),
							},
						])
					}
				}}
				options={options}
			/>
		</div>
	)
}

export default StatSelect
